var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSend = function SvgSend(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 18 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.4 15.424a.99.99 0 0 1-.95-.088Q0 15.05 0 14.5v-3.725q0-.35.2-.625a.88.88 0 0 1 .55-.35L8 8 .75 6.2a.88.88 0 0 1-.55-.35 1.04 1.04 0 0 1-.2-.625V1.5Q0 .95.45.661A.99.99 0 0 1 1.4.574l15.4 6.5q.625.276.625.925 0 .65-.625.925z"
  })));
};
export default SvgSend;